export default (state = {}, action) => {
  switch (action.type) {
    case 'STATUSBREAKDOWN':
      return Object.assign({}, action.payload);
    default:
      return state;
  }
};
